
// ---------------------------------------------------------------------------------------------------
export var LeafletMapLocalizationTextMapKey: string = "Primitive_LeafletMap";
// ------------------------------------------------------------------------------------------------
export enum eLeafletMapLocalizationLabelKey {
    ShowDetailsBtn = "btn-show-details",
    HideDetailsBtn = "btn-hide-details",
    ShowMarkerValueBtn = "btn-show-marker-value",
    ShowMarkerIconBtn = "btn-show-marker-icon",

    DrawPolylineBtn = "btn-draw-polyline",
    DrawPolylineBtnError = "btn-draw-polyline-error",
    DrawPolylineBtnTooltipStart = "btn-draw-polyline-tooltip-start",
    DrawPolylineBtnTooltipCont = "btn-draw-polyline-tooltip-cont",
    DrawPolylineBtnTooltipEnd = "btn-draw-polyline-tooltip-end",

    DrawToolbarPolygonBtn = "btn-draw-polygon",
    DrawPolygonBtnTooltipStart = "btn-draw-polygon-tooltip-start",
    DrawPolygonBtnTooltipCont = "btn-draw-polygon-tooltip-cont",
    DrawPolygonBtnTooltipEnd = "btn-draw-polygon-tooltip-end",

    DrawRectangleBtn = "btn-draw-rectangle",
    DrawRectangleBtnTooltipStart = "btn-draw-rectangle-tooltip-start",
    DrawRectangleBtnTooltipEnd = "btn-draw-rectangle-tooltip-end",

    DrawMarkerBtn = "btn-draw-marker",
    DrawMarkerBtnTooltip = "btn-draw-marker-tooltip",

    DrawToolbarActionTitle = "btn-draw-toolbar-action-title",
    DrawToolbarActionText = "btn-draw-toolbar-action-text",

    DrawToolbarFinishTitle = "btn-draw-toolbar-finish-title",
    DrawToolbarFinishText = "btn-draw-toolbar-finish-text",

    DrawToolbarUndoTitle = "btn-draw-toolbar-undo-title",
    DrawToolbarUndoText = "btn-draw-toolbar-undo-text",

    EditLayersBtn = "btn-edit-layers",
    EditLayersBtnDisabled = "btn-edit-layers-disabled",

    DeleteLayersBtn = "btn-delete-layers",
    DeleteLayersBtnDisabled = "btn-delete-layers-disabled",

    SaveLayersBtn = "btn-save-layers",

    EditToolbarSaveBtnText = "btn-toolbar-save",
    EditToolbarSaveBtnTitle = "btn-toolbar-save-title",

    EditToolbarEditBtnText = "btn-toolbar-edit",
    EditToolbarEditBtnTitle = "btn-toolbar-edit-title",

    EditToolbarClearBtnText = "btn-toolbar-clear",
    EditToolbarClearBtnTitle = "btn-toolbar-clear-title",

    EditHandleTooltipText = "btn-toolbar-edit-tooltip-text",
    EditHandleTooltipSubText = "btn-toolbar-edit-tooltip-subtext",

    RemoveHandleTooltipText = "btn-toolbar-remove-tooltip-text",

    FitToContents = "btn-fit-to-contents"
};
// ---------------------------------------------------------------------------------------------------
export var LeafletMapLocalizationDictionary = {
    [eLeafletMapLocalizationLabelKey.ShowDetailsBtn]: "Detailed view: enabled",
    [eLeafletMapLocalizationLabelKey.HideDetailsBtn]: "Detailed view: disabled",
    [eLeafletMapLocalizationLabelKey.ShowMarkerValueBtn]: "Show the value of markers",
    [eLeafletMapLocalizationLabelKey.ShowMarkerIconBtn]: "Show the icon of markers",

    [eLeafletMapLocalizationLabelKey.DrawPolylineBtn]: "Draw a polyline",
    [eLeafletMapLocalizationLabelKey.DrawPolylineBtnError]: "Error: shape edges cannot cross!",
    [eLeafletMapLocalizationLabelKey.DrawPolylineBtnTooltipStart]: "Click to start drawing line.",
    [eLeafletMapLocalizationLabelKey.DrawPolylineBtnTooltipCont]: "Click to continue drawing line.",
    [eLeafletMapLocalizationLabelKey.DrawPolylineBtnTooltipEnd]: "Click last point to finish line.",

    [eLeafletMapLocalizationLabelKey.DrawToolbarPolygonBtn]: "Draw a polygon",
    [eLeafletMapLocalizationLabelKey.DrawPolygonBtnTooltipStart]: "Click to start drawing shape.",
    [eLeafletMapLocalizationLabelKey.DrawPolygonBtnTooltipCont]: "Click to continue drawing shape.",
    [eLeafletMapLocalizationLabelKey.DrawPolygonBtnTooltipEnd]: "Click first point to close this shape.",

    [eLeafletMapLocalizationLabelKey.DrawRectangleBtn]: "Draw a rectangle",
    [eLeafletMapLocalizationLabelKey.DrawRectangleBtnTooltipStart]: "Click and drag to draw rectangle.",
    [eLeafletMapLocalizationLabelKey.DrawRectangleBtnTooltipEnd]: "Release mouse to finish drawing.",

    [eLeafletMapLocalizationLabelKey.DrawMarkerBtn]: "Draw a marker",
    [eLeafletMapLocalizationLabelKey.DrawMarkerBtnTooltip]: "Click map to place marker.",

    [eLeafletMapLocalizationLabelKey.DrawToolbarActionTitle]: "Cancel drawing",
    [eLeafletMapLocalizationLabelKey.DrawToolbarActionText]: "Cancel",

    [eLeafletMapLocalizationLabelKey.DrawToolbarFinishTitle]: "Finish drawing",
    [eLeafletMapLocalizationLabelKey.DrawToolbarFinishText]: "Finish",

    [eLeafletMapLocalizationLabelKey.DrawToolbarUndoTitle]: "Delete last point drawn",
    [eLeafletMapLocalizationLabelKey.DrawToolbarUndoText]: "Delete last point",

    [eLeafletMapLocalizationLabelKey.EditLayersBtn]: "Edit layers",
    [eLeafletMapLocalizationLabelKey.EditLayersBtnDisabled]: "No layers to edit",

    [eLeafletMapLocalizationLabelKey.DeleteLayersBtn]: "Delete layers",
    [eLeafletMapLocalizationLabelKey.DeleteLayersBtnDisabled]: "No layers to delete",

    [eLeafletMapLocalizationLabelKey.SaveLayersBtn]: "Save layers",

    [eLeafletMapLocalizationLabelKey.EditToolbarSaveBtnTitle]: "Save changes",
    [eLeafletMapLocalizationLabelKey.EditToolbarSaveBtnText]: "Save",

    [eLeafletMapLocalizationLabelKey.EditToolbarEditBtnTitle]: "Cancel editing, discards all changes",
    [eLeafletMapLocalizationLabelKey.EditToolbarEditBtnText]: "Cancel",

    [eLeafletMapLocalizationLabelKey.EditToolbarClearBtnTitle]: "Clear all layers",
    [eLeafletMapLocalizationLabelKey.EditToolbarClearBtnText]: "Clear All",

    [eLeafletMapLocalizationLabelKey.EditHandleTooltipText]: "Drag handles or markers to edit features.",
    [eLeafletMapLocalizationLabelKey.EditHandleTooltipSubText]: "Click cancel to undo changes.",

    [eLeafletMapLocalizationLabelKey.RemoveHandleTooltipText]: "Click on a feature to remove.",

    [eLeafletMapLocalizationLabelKey.FitToContents]: "Fit to contents",
}
// ---------------------------------------------------------------------------------------------------